// 「候補」に残した市区町村コード。localStorage は境界なので、壊れた値・例外の防御はここだけで行い、
// 呼び出し側は string[] を無条件に信頼する（boundary-discipline）。
export const FAVORITES_KEY = "anju:favorites:v1";
export const FAVORITES_MAX = 20;

export function loadFavorites(storage: Pick<Storage, "getItem">): string[] {
  try {
    const raw = storage.getItem(FAVORITES_KEY);
    if (raw === null) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === "string").slice(-FAVORITES_MAX);
  } catch {
    return [];
  }
}

/** プライベートモードや容量超過で setItem が投げても、★ の操作自体は成立させたい。 */
export function saveFavorites(storage: Pick<Storage, "setItem">, codes: string[]): void {
  try {
    storage.setItem(FAVORITES_KEY, JSON.stringify(codes));
  } catch {
    // 保存できないだけで、このセッションの候補は保持される
  }
}

export function toggleFavorite(codes: string[], code: string): string[] {
  if (codes.includes(code)) return codes.filter((c) => c !== code);
  return [...codes, code].slice(-FAVORITES_MAX);
}
